import React, { createContext, useCallback, useContext, useState } from 'react';
import ModalBasic from './ModalBasic';
import CreditPackModal from './CreditPackModal';

const CreditModalContext = createContext({ openCreditModal: () => {}, closeCreditModal: () => {} });

/**
 * Mounts a single, globally-controllable credit-pack modal.
 * Anywhere in the app can call `useCreditModal().openCreditModal({ campaignId })`
 * to show the picker without navigating away from the current screen.
 */
export function CreditModalProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [campaignId, setCampaignId] = useState(null);

  const openCreditModal = useCallback((opts = {}) => {
    setCampaignId(opts.campaignId || null);
    setOpen(true);
  }, []);
  const closeCreditModal = useCallback(() => setOpen(false), []);

  return (
    <CreditModalContext.Provider value={{ openCreditModal, closeCreditModal }}>
      {children}
      <ModalBasic
        id="global-credit-pack-modal"
        title="Get publish credits"
        modalOpen={open}
        setModalOpen={setOpen}
        widthClass="max-w-2xl"
      >
        <CreditPackModal campaignId={campaignId} onClose={closeCreditModal} />
      </ModalBasic>
    </CreditModalContext.Provider>
  );
}

export function useCreditModal() {
  return useContext(CreditModalContext);
}
